import { DigitalTransfersModuleRouter } from "./router";

const DigitalTransfersModule = (moduleConfig = {}) => ({
    pathBase: '/',
    componentRouter: DigitalTransfersModuleRouter,
});

export default DigitalTransfersModule;